import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";
import api from '@/api'
import cache from '@/utils/cached'
Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      paths: ['createParam', 'userInfo'],
      storage: window.sessionStorage
    })
  ],
  state: {
    userRole: '',
    createParam: {},
    userInfo: {},
    jsApiDataList: [],
    isRefundOrderPop: true,
    jjInfo: false,
    isShowInformPop: true,
  },
  mutations: {
    cacheCreateParam: (state, params) => {
      state.createParam = params;
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    setJsApiData(state, apiData) {
      state.jsApiDataList = [... state.jsApiDataList, apiData];
    },
    setRefundOrderPop(state, value) {
      state.isRefundOrderPop = value
    },
    // 进件信息
    setJjInfo(state, jjInfo) {
      state.jjInfo = jjInfo
    },
    // 信息弹窗
    setIsShowInformPop(state, value) {
      state.isShowInformPop = value
    }
  },
  actions: {
    getUserInfo({ commit }) {
      return api.common.getUserInfo(cache.getOpenId())
        .then(({data}) => {
          if (data) {
            // 在活动老师权限基础上添加分享权限
            if (data.roleCode === '5') {
              data.roleCode = 4
              data.countAuthority = true
            }
            commit('setUserInfo', data)
          }
        }).catch(error => {
          console.log(error);
        });
    }
  },
  getters: {
    isDistributor(state) {
      // 经销商
      return state.userInfo.roleCode == 1;
    },
    isShopowner(state) {
      // 店长
      return state.userInfo.roleCode == 2;
    },
    isGuide(state) {
      // 导购
      return state.userInfo.roleCode == 3;
    },
    isTeacher(state) {
      // 活动老师
      return state.userInfo.roleCode == 4;
    },
    userInfo(state) {
      return state.userInfo;
    },
    getJsApiDataByPage: (state) => (url) => {
      return state.jsApiDataList.find(page => page.url === url);
    }
  }
})